if (!customElements.get('sc-design-related')) {
  customElements.define('sc-design-related', class extends HTMLElement {
    connectedCallback() {
      if (this.loaded) return;
      this.loaded = true;
      this.addEventListener('change', (event) => {
        const select = event.target.closest('select');
        if (!select) return;
        const source = select.selectedOptions[0]?.dataset.image;
        const image = select.closest('.same-collection-card')?.querySelector('img');
        if (source && image) image.src = source;
      });
      this.loadProducts();
    }

    async loadProducts() {
      const url = new URL(this.dataset.searchUrl, location.origin);
      url.searchParams.set('q', this.dataset.designKey);
      url.searchParams.set('type', 'product');
      url.searchParams.set('view', 'design-related');
      url.searchParams.set('options[unavailable_products]', 'last');
      const preview = new URL(location.href).searchParams.get('preview_theme_id');
      if (preview) url.searchParams.set('preview_theme_id', preview);
      const seen = new Set([this.dataset.productId]);
      const cards = [];
      try {
        let page = url;
        for (let count = 0; page && count < 5 && cards.length < 10; count++) {
          const response = await fetch(page, { credentials: 'same-origin' });
          if (!response.ok) throw new Error('Related products request failed');
          const html = new DOMParser().parseFromString(await response.text(), 'text/html');
          for (const card of html.querySelectorAll('[data-design-results] .same-collection-card')) {
            if (card.dataset.designKey !== this.dataset.designKey || seen.has(card.dataset.productId)) continue;
            seen.add(card.dataset.productId);
            cards.push(card);
            if (cards.length === 10) break;
          }
          const next = html.querySelector('[data-design-next]')?.getAttribute('href');
          page = next ? new URL(next, url) : null;
          if (page) {
            page.searchParams.set('view', 'design-related');
            if (preview) page.searchParams.set('preview_theme_id', preview);
          }
        }
        if (!this.isConnected || !cards.length) return;
        this.querySelector('.same-collection-grid').replaceChildren(...cards);
        this.hidden = false;
      } catch (error) {
        console.error('Unable to load same-design products.', error);
      }
    }
  });
}
